// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skel {
  background: linear-gradient(
    90deg,
    var(--border-soft) 0%,
    var(--bg-alt) 50%,
    var(--border-soft) 100%
  );
  background-size: 200% 100%;
  border-radius: var(--radius-1);
  height: 12px;
  animation: skel-shimmer 1.4s linear infinite;
}

.skel--dark {
  background: linear-gradient(
    90deg,
    var(--ink-dark-2) 0%,
    #14224a 50%,
    var(--ink-dark-2) 100%
  );
  background-size: 200% 100%;
}

@keyframes skel-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skel--h22 {
  height: 22px;
}
.skel--h32 {
  height: 32px;
}
.skel--h48 {
  height: 48px;
}
.skel--w30 {
  width: 30%;
}
.skel--w50 {
  width: 50%;
}
.skel--w70 {
  width: 70%;
}
.skel--w90 {
  width: 90%;
}

.skel-ledger-row {
  display: grid;
  grid-template-columns: 24px 1fr 100px 80px 80px 80px;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-soft);
}

.skel-kpi-hero {
  padding: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Skeleton/Skeleton.css"],"names":[],"mappings":"AAAA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,8BAA8B;EAC9B,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf","sourcesContent":[".skel {\n  background: linear-gradient(\n    90deg,\n    var(--border-soft) 0%,\n    var(--bg-alt) 50%,\n    var(--border-soft) 100%\n  );\n  background-size: 200% 100%;\n  border-radius: var(--radius-1);\n  height: 12px;\n  animation: skel-shimmer 1.4s linear infinite;\n}\n\n.skel--dark {\n  background: linear-gradient(\n    90deg,\n    var(--ink-dark-2) 0%,\n    #14224a 50%,\n    var(--ink-dark-2) 100%\n  );\n  background-size: 200% 100%;\n}\n\n@keyframes skel-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skel--h22 {\n  height: 22px;\n}\n.skel--h32 {\n  height: 32px;\n}\n.skel--h48 {\n  height: 48px;\n}\n.skel--w30 {\n  width: 30%;\n}\n.skel--w50 {\n  width: 50%;\n}\n.skel--w70 {\n  width: 70%;\n}\n.skel--w90 {\n  width: 90%;\n}\n\n.skel-ledger-row {\n  display: grid;\n  grid-template-columns: 24px 1fr 100px 80px 80px 80px;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.skel-kpi-hero {\n  padding: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
